import { h } from 'vue'
import OrganismStatistics from '~/components/organisms/statistics/statistics.vue'
import UiComponentContainer from '~ui/components/container/container.vue'

const Functional = (props) => {
  return h(UiComponentContainer, { class: 'tei' }, () => [
    h(OrganismStatistics, {
      logo: props.record.isLocalized
        ? props.record.content.logo
        : props.statistics.logo,
      statistics: [
        ...(props.record.isLocalized
          ? props.record.content.statistics
          : props.statistics.statistics
        ).map((stat, index) => ({
          backgroundColor: ['#F6F7F9', '#F1F7F9', '#FDF7F7', '#FDF7F7'][
            index
          ],
          ...stat,
        })),
      ],
    }, {
      title: () =>
        props.record.isLocalized
          ? props.record.content.title
          : props.statistics.title,
      by: () =>
        props.record.isLocalized ? props.record.content.by : props.statistics.by,
    }),
  ])
}

Functional.props = {
  record: {
    required: true,
    type: Object,
  },
  statistics: {
    required: true,
    type: Object,
  },
}

export default Functional
